export interface ApplicantRoleModel {
  id: number;
  name: string;
  key: string;
  description: string | null;
}

export interface ApplicantRoleDto {
  id: number;
  name: string;
  key: string;
  description: string | null;
}

export const applicantRoleBuilder = {
  fromBackend: (dto: ApplicantRoleDto): ApplicantRoleModel => ({
    id: dto.id,
    name: dto.name,
    key: dto.key,
    description: dto.description
  })
};
